  import axios from '@/libs/api.request'


/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const urlEdit = (data) => {
  return axios.request({
    url: 'Lhc/urlEdit',
    method: 'post',
    data
  })
}


/**
 * 获取数据
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const urlGet = (data) => {
  return axios.request({
    url: 'Lhc/urlGet',
    method: 'post',
    data
  })
}


/**
 * 获取数据
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const moduleDataGetList = (data) => {
  return axios.request({
    url: 'Lhc/moduleDataGetList',
    method: 'post',
    data
  })
}


/**
 * 获取数据
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const moduleDataEdit = (data) => {
  return axios.request({
    url: 'Lhc/moduleDataEdit',
    method: 'post',
    data
  })
}


  /**
   * 自定义请求,将所有请求统一方法
   */
  export const customPost = (url,data) => {
    return axios.request({
      url: url,//'Lhc/fieldGetList',
      method: 'post',
      data
    })
  }






